import { useAuth } from "@/hooks/useAuth";
import type { HttpError } from "@/ts/api/comunicacion";
import styles from "./Loading.module.css";

export function QueryError(props: { readonly error: unknown; readonly fallback: string; }) {
	const { setAuth } = useAuth();

	let message = props.fallback;
	if (props.error != null && typeof props.error === "object" && "status" in props.error) {
		const error = props.error as HttpError;
		if (error.status === 401) {
			setAuth(null);
			message = "Sesión expirada. Por favor, inicie sesión de nuevo.";
		} else if (error.status === 403) {
			message = "No tiene permiso para realizar esta acción.";
		}
	}


	return (
		<div style={{ padding: 20, color: "red", fontWeight: "bold" }}>
			{message}
		</div>
	);
}

interface LoadingProps {
	readonly style?: React.CSSProperties;
}
export function Loading(props: LoadingProps) {
	return (
		<div >
			<div className={styles.loader} style={props.style}>
				<div />
				<div />
				<div />
			</div>
		</div>
	);
}